import React, { Component } from "react";
import { DateBox, ComboBox } from "rc-easyui";
import { Button } from "reactstrap";
import setTitle from "../../helpers/TitleComponent";
import { getAccessToken, getCookie } from "../../helpers/cookieHelper";
import {
  isEmpty,
  getFormattedDate,
  isEmptyString,
  exportToCSV,
} from "../../helpers";
import { API_URL } from "../../constants";
import "./Report.css";

const axios = require("axios");

export default class ClientLedgerReport extends Component {
  constructor() {
    super();
    this.state = {
      clientInfo: {},
      data: [],
      tableFooter: {
        balance: 0,
        credit: 0,
        debit: 0,
      },
      isLoading: false,
      form: {
        clientid: "",
        fromdate: "",
        todate: "",
      },
      clients: [],
    };
    this.generateReport = this.generateReport.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
  }

  async getClientsForComboBox() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allclientinfo`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              clients: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  }
  handleChange(name, value) {
    let form = Object.assign({}, this.state.form);

    if (name === "clientid") {
      form[name] = isEmptyString(value) ? "" : value;
      this.setState({ form: form, data: [] });
    } else {
      form[name] = value;
      this.setState({ form: form });
    }

    //console.log(value);
  }

  componentDidMount() {
    setTitle("Client Ledger Report");
    this.getClientsForComboBox();
  }

  async generateReport() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.state.form);
    if ((form.fromdate == "") & (form.todate == "")) {
      alert("From and To date is required");
      return;
    }
    form["fromdate"] = getFormattedDate(form["fromdate"]);
    form["todate"] = getFormattedDate(form["todate"]);

    let apiUrl = `${API_URL}api/clientledger?clientid=${form.clientid}&fromdate=${form.fromdate}&todate=${form.todate}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };

    //No Form Validation Error
    if (token != null) {
      //Access Token Available
      this.setState({
        isLoading: true,
      });
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          //console.log("response", response);
          if (response.status === 200) {
            this.setState({
              isLoading: false,
            });
            if (response.data.status) {
              var data = [];
              var clientInfo = {};
              var tableFooter = {};
              if (form["clientid"] === "") {
                data = response.data.object;
                tableFooter = response.data.transacctionsummary;
                //console.log(tableFooter);
                if (data.length === 0) {
                  alert("No Data Found");
                  return;
                }
                clientInfo = {};
                this.setState({
                  clientInfo: clientInfo,
                  data: data,
                  tableFooter: tableFooter,
                });
              } else {
                data = response.data.object.datarecords;
                clientInfo = response.data.object.topheader;
                tableFooter = response.data.object.transacctionsummary;
                if (data.length === 0) {
                  alert("No Data Found");
                  return;
                }
                this.setState({
                  clientInfo: clientInfo,
                  data: data,
                  tableFooter: tableFooter,
                });
              }
            } else {
              alert("No data found");
            }
            // this.props.formClear();
          } else {
            this.setState({
              isLoading: false,
            });
            alert("Uncaught error");
          }
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });
          alert("Internal Server Error");
        });
    } else {
      //Access Token Expired.
      //Generate new Access Token using Refresh Token.
      const resp = await getAccessToken();
      if (resp) {
        this.generateReport();
      }
    }
  }
  print() {
    window.print();
    window.location.reload();
  }
  exportToExcel() {
    exportToCSV(this.state.data, "Client Ledger Report" + Date());
  }
  render() {
    const clientInfo = this.state.clientInfo;
    const tableFooter = this.state.tableFooter;
    const loading = this.state.isLoading;
    // //console.log(tableFooter);
    return (
      <div className='container-fluid'>
        <div className='noprint'>
          <div
            className='loadingmodel'
            style={{ display: loading ? "block" : "none" }}
          ></div>
          <p className='text-danger'>Fields with * are mandatory</p>
          <div className='row'>
            <div className='col-12 col-md-4'>
              <b>Client</b>
              <ComboBox
                style={{ width: "100%" }}
                data={this.state.clients}
                onChange={(e) => this.handleChange("clientid", e)}
                // value={form.clientName}
                valueField='clientid'
                textField='organizationname'
              ></ComboBox>
            </div>
            <div className='col-12 col-md-2'>
              <b>
                From <span className='text-danger'>*</span>
              </b>
              <br />

              <DateBox
                inputId='fromdate'
                format='yyyy-MM-dd'
                style={{ width: "100%" }}
                // value={form.start_date}
                onChange={(e) => this.handleChange("fromdate", e)}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </div>
            <div className='col-12 col-md-2'>
              <b>
                To <span className='text-danger'>*</span>
              </b>

              <br />
              <DateBox
                inputId='todate'
                format='yyyy-MM-dd'
                style={{ width: "100%" }}
                // value={form.start_date}
                onChange={(e) => this.handleChange("todate", e)}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </div>
            <div className='col-12 col-md-3 mt-3'>
              <Button
                className='mx-1'
                onClick={this.generateReport}
                color='primary'
              >
                Generate
              </Button>
              <Button
                className='mx-1'
                onClick={this.exportToExcel}
                color='success'
              >
                Export
              </Button>
              <Button className='mx-1' onClick={this.print} color='info'>
                Print
              </Button>
            </div>
          </div>
        </div>
        <br />
        {this.state.data.length > 0 &&
        !isEmptyString(this.state.form.clientid) ? (
          <div className='row mx-2'>
            <div
              className='col-12 mb-2'
              style={{ margin: "0px", width: "100%" }}
            >
              <h5
                className='text-center'
                style={{ fontWeight: 900, fontSize: "22pt" }}
              >
                Infox IT Pvt. Ltd
              </h5>
              <h6
                className='text-center'
                style={{ fontWeight: 900, fontSize: "18pt" }}
              >
                Butwal-8, Sukkhanagar, Rupandehi,
              </h6>

              <h4
                className='text-center'
                style={{ fontWeight: 900, fontSize: "19pt" }}
              >
                Client Ledger Report
              </h4>
              <br />
              <p style={{ marginBottom: 10 }}>
                <span
                  className=''
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Client Name:
                  {isEmpty(clientInfo) ? "-" : clientInfo.clientname}
                </span>
                <span
                  className='float-right'
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Email: {isEmpty(clientInfo) ? "" : clientInfo.email}
                </span>
              </p>

              <p style={{ marginBottom: 10 }}>
                <span
                  className=''
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Address:
                  {isEmpty(clientInfo) ? "-" : clientInfo.address}
                </span>
                <span
                  className='float-right'
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Contact:
                  {isEmpty(clientInfo) ? "" : clientInfo.phoneno}
                </span>
              </p>
            </div>

            <table className='table table-bordered report-table'>
              <thead>
                <tr>
                  <th width='5%'>S.N.</th>
                  <th width='20%'>Transaction Date</th>
                  <th width='15%'>Credit</th>
                  <th width='15%'>Debit</th>
                  <th>Particular</th>
                </tr>
              </thead>
              <tbody>
                {this.state.data.map((row, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{getFormattedDate(row.transactiondate)}</td>
                    <td>Rs. {row.credit.toFixed(2)}</td>
                    <td>Rs. {row.debit.toFixed(2)}</td>

                    <td>{row.particular}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={2} className='text-center'>
                    Total
                  </th>
                  <th>Rs. {tableFooter.credit.toFixed(2)}</th>
                  <th>Rs. {tableFooter.debit.toFixed(2)}</th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          ""
        )}

        {this.state.data.length > 0 &&
        isEmptyString(this.state.form.clientid) ? (
          <div className='row mx-2'>
            <div
              className='col-12 mb-2'
              style={{ margin: "0px", width: "100%" }}
            >
              <h5
                className='text-center'
                style={{ fontWeight: 900, fontSize: "22pt" }}
              >
                Infox IT Pvt. Ltd
              </h5>
              <h6
                className='text-center'
                style={{ fontWeight: 900, fontSize: "18pt" }}
              >
                Butwal-8, Sukkhanagar, Rupandehi,
              </h6>

              <h4
                className='text-center'
                style={{ fontWeight: 900, fontSize: "19pt" }}
              >
                Client Ledger Report
              </h4>
              <br />
            </div>

            <table className='table table-bordered report-table'>
              <tr>
                <th width='5%'>S.N.</th>
                <th width='25%'>Client Name</th>
                <th width='20%'>Client Address</th>
                <th width='10%'>Credit</th>
                <th width='10%'>Debit</th>
                <th width='10%'>Balance</th>
              </tr>

              {this.state.data.map((row, i) => (
                <tr>
                  <td>{i + 1}</td>
                  <td>{row.clientname}</td>
                  <td>{row.address}</td>
                  <td>Rs. {row.credit.toFixed(2)}</td>
                  <td>Rs. {row.debit.toFixed(2)}</td>
                  <td>{row.balance.toFixed(2)}</td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
